export function buildLessonWebSocketUrl({
  baseUrl,
  sessionId,
  token,
  demoClientId,
}) {
  const fullUrl = new URL(`${baseUrl}/session/${sessionId}`);

  if (token) {
    fullUrl.searchParams.set("token", token);
  }

  if (demoClientId) {
    fullUrl.searchParams.set("demo_client_id", demoClientId);
  }

  return fullUrl.toString();
}
